import React from "react";
import { Link } from "react-router-dom";
import bannerimage from "../assets/images/banner.png"
const Banner = () => {
  return (
   <div className="elementor-widget-container">
       <div className="banner-area auto-height text-color bg-gray inc-shape">
         <div className="item">
           <div className="container">
             <div className="row align-center">
               {/* Text Content */}
               <div className="col-lg-6 col-sm-12 col-md-6 col-xl-6">
                 <div className="content">
                   
                   <h2 className="wow fadeInDown" style={{ visibility: "visible", animationName: "fadeInDown" }}>
                 KnackHire
                   </h2>
                   <h3 className="tagline">
                   <strong style={{fontSize:'50px',fontWeight:'800',color:'#00a7ac'}}>AI-Powered Staffing Solution</strong>
                   </h3>
                  <p className="wow fadeInLeft" style={{ visibility: "visible", animationName: "fadeInLeft" }}>
                   All-in-one staffing solution that streamlines job and candidate management, resume parsing, and AI-driven matching. It offers advanced video and coding assessments, submission tracking, and facilitates seamless client, vendor, and team collaboration for efficient hiring.
                   </p>
                   <Link to="/Home">
                     <a className="btn circle btn-theme effect btn-md wow fadeInUp" href="#" style={{ visibility: "visible", animationName: "fadeInUp" }}>
                       Start Now <i className=""></i>
                     </a>
                   </Link>
                 </div>
               </div>
 
               {/* Image */}
               <div className="col-lg-6 col-sm-12 col-md-6 col-xl-6">
               <div id="carouselWithCaptions" className="carousel slide" data-bs-ride="carousel">
   <div className="carousel-inner">
     {/* login */}
     <div className="carousel-item active">
       <div>
         <img
           src={bannerimage}
           className="img-fluid"
           alt="Slide 1"
           style={{ objectFit: "contain", height:'300px',width:'600px',marginTop:'50px',marginBottom:'120px'}}
         />
         <div className="carousel-caption d-none d-md-block">
           {/* <p style={{ fontSize: '15px', color: '#00a7ac' }}>
             Secure login tailored for your branding role - Personal, Business, or Agency.
           </p>*/}
         </div>
       </div>
     </div>
 
     {/* profile tools */}
     <div className="carousel-item">
       <img
         src={bannerimage}
         className="img-fluid"
         alt="Slide 2"
         style={{ objectFit: "contain", height:'300px',width:'600px',marginTop:'50px',marginBottom:'120px'}}
       />
       <div className="carousel-caption d-none d-md-block">
         {/* <p style={{ fontSize: '15px', color: '#00a7ac' }}>
           Customize your profile, prompts, and interests with powerful AI-driven tools.
         </p>*/}
       </div>
     </div>
 
     {/* post tool */}
     <div className="carousel-item">
       <img
         src={bannerimage}
         className="img-fluid"
         alt="Slide 3"
         style={{ objectFit: "contain", height:'300px',width:'600px',marginTop:'50px',marginBottom:'120px'}}
       />
       <div className="carousel-caption d-none d-md-block">
        {/*  <p style={{ fontSize: '15px', color: '#00a7ac' }}>
           Seamlessly manage, schedule, and track all your posts from one unified hub.
         </p>*/}
       </div>
     </div>
 
  
 
   </div>
   
 
   {/* Carousel Controls */}
   <div
     className="carousel-control-prev"
     type="button"
     data-bs-target="#carouselWithCaptions"
     data-bs-slide="prev"
     style={{ width: "30px"}}
   >
     <span
       className="carousel-control-prev-icon"
       aria-hidden="true"
       style={{ backgroundColor: "#00a7ac", borderRadius: "50%", width: "15px", height: "15px" }}
     ></span>
     <span className="visually-hidden">Previous</span>
   </div>
   <div
     className="carousel-control-next"
     type="button"
     data-bs-target="#carouselWithCaptions"
     data-bs-slide="next"
     style={{ width: "30px" }}
   >
     <span
       className="carousel-control-next-icon"
       aria-hidden="true"
       style={{ backgroundColor: "#00a7ac", borderRadius: "50%", width: "15px", height: "15px"}}
     ></span>
     <span className="visually-hidden">Next</span>
   </div>
 </div>
 
 </div>
 
             </div>
           </div>
         </div>
       </div>
       <style jsx>{`
        .banner-area.auto-height, .banner-area.auto-height div {
          height: auto;
        }
        .banner-area .content {
          padding: 70px 0;
        }
        .banner-area .content h4 {
          margin-bottom: 25px;
        }
        .banner-area .content h2 {
          font-size: 60px;
          margin-bottom: 25px;
        }
        .banner-area .content a {
          margin-top: 20px;
        }
        .banner-area .row.align-center div {
          height: auto;
        }
        .banner-area.inc-shape .thumb {
          position: relative;
          z-index: 1;
        }
        .banner-area .thumb {
          position: relative;
        }
        .elementor img {
          height: auto;
          max-width: 100%;
          border: none;
          border-radius: 0;
          box-shadow: none;
        }
        .banner-area .row.align-center div {
          height: auto;
        }
        .banner-area.inc-shape .thumb {
          position: relative;
          z-index: 1;
        }
        .banner-area.text-color .content h2 strong {
          font-weight: 800;
          color: #00a7ac;
        }
        .banner-area .content h2 {
          font-size: 35px;
          margin-bottom: 25px;
        }
        p {
          color: #666;
          margin: 0 0 15px;
          text-transform: none;
          font-weight: 400;
          line-height: 26px;
          font-size: 14px;
        }
        a.btn.circle.btn-theme.effect.btn-md.wow.fadeInUp {
          background-color: #00a7ac;
          color: #fff;
          padding: 13px;
          border-radius: 56px;
          font-size: 16px;
          font-weight: bold;
        }

        /* Responsive Styles */
        @media (max-width: 992px) {
          .banner-area .content h2 {
            font-size: 50px;
          }
          .banner-area .content p {
            font-size: 16px;
            margin-bottom: 20px;
          }
          .banner-area .content a {
            font-size: 14px;
            padding: 10px 20px;
          }
          .banner-area img {
            height: auto;
            max-width: 90%;
            margin-top: 20px;
          }
        }

        @media (max-width: 768px) {
          .banner-area .content h2 {
            font-size: 40px;
          }
          .banner-area .content p {
            font-size: 14px;
          }
          .banner-area .content a {
            font-size: 13px;
            padding: 10px 18px;
          }
          .banner-area img {
            height: auto;
            max-width: 80%;
            margin-top: 20px;
          }
        }

        @media (max-width: 576px) {
          .banner-area .content h2 {
            font-size: 30px;
          }
          .banner-area .content p {
            font-size: 12px;
          }
          .banner-area .content a {
            font-size: 12px;
            padding: 8px 16px;
          }
          .banner-area img {
            height: auto;
            max-width: 100%;
            margin-top: 10px;
          }
       
@media (max-width: 576px) {
  .banner-area img {
    height: auto;
    max-width: 100%;
    margin-top: 10px !important;
    margin-bottom: 10px !important;
  }

  .carousel-item img {
    margin-top: 10px !important;
    margin-bottom: 10px !important;
  }
       `}</style>
     </div>
  );
};

export default Banner;
